export default __webpack_public_path__ + "static/media/mix.ddbdd477.mp4";